import React, { useEffect, useState } from 'react';
import { makeStyles } from '@mui/styles';
import {
    Box,
    Paper,
    TextField,
    Typography,
    InputAdornment,
    Button,
    Chip,
    IconButton,
    Stack,
    Skeleton,
} from '@mui/material';
import Header from '../../components/navigation/Header';
import SearchIcon from "@mui/icons-material/Search";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import Barcode from "../../assets/MyExams/Barcode.jpg";
import GlobalModal from './GlobalModal';
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { useLocation, useNavigate } from "react-router-dom";
import KenTable from '../../components/KenTable';
import { useMediaQuery, useTheme } from "@mui/material";
import { allBooklets, updateBundleStatus } from '../../utils/apiService';
import { useLoader } from '../../components/KenLoader';
import { useSnackbar } from '../../components/KenSnackbar';
import { formatDisplayDate } from '../../utils/dateUtils';

const useStyles = makeStyles(() => ({
    header: {
        fontSize: '18px !important',
        fontWeight: '500 !important',
    },
    container: {
        borderRadius: '8px',
        marginTop: '32px',
        height: 'calc(100vh - 265px)',
        position: 'relative',
        overflow: 'auto',
        background: '#FFF'
    },
    tabRoot: {
        textTransform: 'capitalize', // keep tab labels capitalized
        fontSize: '16px',
        fontWeight: 500,
    },
    RightChip: {
        fontSize: '14px !important',
        background: "#E8EBF3",
        padding: '6px 8px',
        borderRadius: "100px"
    },
    mobileWrapper: {
        padding: '16px',
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        paddingBottom: '80px',
        minHeight: '100vh',
        backgroundColor: '#F3F4F8'
    },
    mobileSummary: {
        backgroundColor: '#FFFFFF',
        borderRadius: '14px',
        boxShadow: '0px 10px 30px rgba(15, 23, 42, 0.08)',
        padding: '16px',
        display: 'flex',
        flexDirection: 'column',
        gap: '8px'
    },
    mobileHeading: {
        fontSize: '16px',
        fontWeight: 700,
        color: '#171821',
        lineHeight: 1.3,
    },
    mobileMeta: {
        fontSize: '13px',
        color: '#6B7280'
    },
    mobileDueChip: {
        alignSelf: 'flex-start',
        fontSize: '12px',
        fontWeight: 600,
        padding: '6px 12px',
        borderRadius: '999px',
        backgroundColor: '#FEEDEA',
        color: '#B3402A'
    },
    mobileSection: {
        display: 'flex',
        flexDirection: 'column',
        gap: '12px'
    },
    mobileSectionTitle: {
        fontSize: '16px',
        fontWeight: 600,
        color: '#080018'
    },
    mobileSearchField: {
        backgroundColor: '#FFFFFF',
        borderRadius: '12px',
        border: '1px solid #E5E7EB',
        '& .MuiOutlinedInput-root': {
            borderRadius: '12px',
            height: 44
        }
    },
    mobileCard: {
        backgroundColor: '#FFFFFF',
        borderRadius: '16px',
        padding: '14px 14px 18px',
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        boxShadow: '0px 10px 30px rgba(15, 23, 42, 0.06)',
    },
    mobileCardHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    mobileBookletId: {
        fontSize: '15px',
        fontWeight: 700,
        color: '#161B26'
    },
    mobileMarks: {
        fontSize: '13px',
        color: '#4B5563'
    },
    statusChip: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '4px 10px',
        borderRadius: '999px',
        fontSize: '12px',
        fontWeight: 600
    },
    mobileActionBtn: {
        height: 44,
        borderRadius: '10px',
        textTransform: 'none',
        fontWeight: 700,
        backgroundColor: '#1F2430',
        color: '#fff',
        '&.Mui-disabled': {
            backgroundColor: '#ECEFF3',
            color: '#9DA3AF',
        }
    },
    mobileFooter: {
        position: 'sticky',
        bottom: 0,
        left: 0,
        right: 0,
        paddingTop: '8px',
        paddingBottom: '8px',
        paddingLeft: '16px',
        paddingRight: '16px',
        display: 'flex',
        justifyContent: 'center',
        marginTop: 'auto',
        zIndex: 1
    },
    submitButton: {
        height: 36,
        borderRadius: '12px',
        textTransform: 'none',
        fontWeight: 600
    }
}));

const renderEmptyState = (message: string) => (
    <Box
        sx={{
            textAlign: "center",
            py: 6,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#6B7280",
        }}
    >
        <Typography>{message}</Typography>
    </Box>
);

const EvaluatioRequests = () => {
    const classes = useStyles();
    const [open, setOpen] = useState<boolean>(false);
    const navigate = useNavigate();
    const theme = useTheme();
    const { state } = useLocation();
    const { showSnackbar } = useSnackbar();
    console.log("Receiadaved data:", state?.data);
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [rows, setRows] = useState<any[]>([]);
    const [search, setSearch] = useState<string>('');
    const { showLoader, hideLoader } = useLoader();
    const [loading, setLoading] = useState<boolean>(true);
    const [fileUploadBase64, setFileUploadBase64] = useState("");
    const [fileInputKey, setFileInputKey] = useState(0);
    const bundleId = state?.data?.AssignedBundleID || state?.data?.bundleCode || state?.data?.id || state?.data;
    const dueDateDisplay = formatDisplayDate(state?.data?.dueDate || state?.data?.EvaluationDueDate || state?.data?.submittedOn);
    const incompleteCounts = React.useMemo(() => {
        return rows.reduce(
            (acc, row) => {
                if (row.EvaluationStatus === 'Completed') {
                    return acc;
                }
                if (row.EvaluationStatus === 'Pending') {
                    acc.pending += 1;
                } else if (row.EvaluationStatus === 'Partially evaluated') {
                    acc.partial += 1;
                } else {
                    acc.pending += 1;
                }
                return acc;
            },
            { pending: 0, partial: 0 }
        );
    }, [rows]);
    const totalIncomplete = incompleteCounts.pending + incompleteCounts.partial;
    const allCompleted = React.useMemo(() => rows.length > 0 && totalIncomplete === 0, [rows, totalIncomplete]);
    const hasEvaluationStarted = React.useMemo(
        () => rows.some((row) => row.EvaluationStatus === 'Completed' || row.EvaluationStatus === 'Partially evaluated'),
        [rows]
    );
    const submitModalTitle = allCompleted ? "Submit bundle" : "Some booklets pending";
    const submitWarningMessage = React.useMemo(() => {
        if (allCompleted) {
            return "All booklets are completed. Submit the bundle?";
        }
        const parts: string[] = [];
        if (incompleteCounts.pending > 0) {
            const count = incompleteCounts.pending;
            parts.push(`${count} booklet${count > 1 ? 's are' : ' is'} pending evaluation`);
        }
        if (incompleteCounts.partial > 0) {
            const count = incompleteCounts.partial;
            parts.push(`${count} booklet${count > 1 ? 's are' : ' is'} partially evaluated`);
        }
        const warning = parts.join(' and ');
        return `${warning}. If you submit now, the remaining booklet${totalIncomplete > 1 ? 's' : ''} will be submitted with no marks (0).\nAre you sure you want to continue?`;
    }, [allCompleted, incompleteCounts.partial, incompleteCounts.pending, totalIncomplete]);

    useEffect(() => {
        showLoader();
        setLoading(true);
        let payload = state?.data?.AssignedBundleID;
        allBooklets(payload).then((res) => {
            hideLoader()
            console.log(res, "all booklets response");
            let response = res?.data;
            let tempArray = response?.map((item: any, index: number) => ({
                id: index + 1,
                bookletId: item?.answerBookletNumber,
                marks: `${item?.compositeScore}/${item?.TotalCourseMarks}`,
                barcode: item?.barcode,
                EvaluationStatus: item?.EvaluationStatus === null ? "Pending" : item?.EvaluationStatus,
                examConnectionRecordId: item?.examConnectionRecordId,
                examid: item?.examid
            }));
            setRows(tempArray || []);
            console.log(response, "dsfbdb");
        }).catch((err) => {
            hideLoader()
            console.log(err)
        }).finally(() => setLoading(false));

    }, []);

    const columns = [
        { field: "bookletId", headerName: "Barcode Number", align: "center" },
        // {
        //     field: "barcode",
        //     headerName: "Bar code",
        //     renderCell: ({ value }: any) => {
        //         // Extract the `src` value
        //         const match = value?.match(/src="([^"]+)"/);
        //         let imgSrc = match ? match[1] : "";

        //         // Decode HTML entities (like &amp;)
        //         imgSrc = imgSrc.replace(/&amp;/g, "&");

        //         console.log("Decoded barcode URL:", imgSrc);

        //         return (
        //             <img
        //                 src={imgSrc}
        //                 alt="barcode"
        //                 style={{
        //                     height: 40,

        //                 }}
        //             />
        //         );
        //     },
        // },
        {
            field: "marks",
            headerName: "Total marks",
            align: "center",
            renderCell: ({ value }: any) => {
                const [scored, total] = String(value ?? "--/--").split("/");
                return (
                    <span>
                        <strong>{scored}</strong>
                        {/* /{total} */}
                    </span>
                );
            },
        },
        {
            field: "EvaluationStatus",
            headerName: "Status",
            align: "center",
            renderCell: ({ value }: any) => {

                let color: "default" | "success" | "warning" = "default";
                let sx = {};

                if (value === "Completed") {
                    color = "success";
                    sx = { backgroundColor: "#E6F4EA", color: "#1E7D34" };
                } else if (value === "Partially evaluated") {
                    sx = { backgroundColor: "#F3F4F6", color: "#374151" };
                } else {
                    color = "warning";
                    sx = { backgroundColor: "#FFF4E5", color: "#B76E00" };
                }

                return (
                    <Chip
                        label={value}
                        sx={{
                            fontWeight: 500,
                            borderRadius: "6px",
                            px: 1,
                            ...sx,
                        }}
                    />
                );
            },
        },
        // {
        //     field: "EvaluationStatus",
        //     headerName: "",
        //     renderCell: ({ row }: any) => {
        //         // console.log(value,"skfdnsnj");

        //         return <Button
        //             variant={row?.EvaluationStatus === "Pending" ? "secondary" : "text"}
        //             size="small"
        //             onClick={() => {

        //                 navigate('/faculty/evaluationDetails', {
        //                     state: {
        //                         data: state,
        //                         rowData: row
        //                     },
        //                 })
        //             }}
        //         >
        //             {row?.EvaluationStatus === "Pending" ? "Evaluate" : "Edit"}
        //         </Button>
        //     },
        // },
    ];

    const resetUploadState = () => {
        setFileUploadBase64("");
        setFileInputKey((prev) => prev + 1);
    };

    const handleBundleSubmit = async () => {
        if (!bundleId) {
            showSnackbar('Bundle information is missing. Please reopen the request.', 'error');
            return;
        }
        showLoader();
        try {
            await updateBundleStatus({
                bundleId,
                bundleEvaluationStatus: 'Completed',
                ...(fileUploadBase64 ? { fileUpload: fileUploadBase64 } : {}),
            });
            showSnackbar('Bundle submitted successfully.', 'success');
            setOpen(false);
            resetUploadState();
            navigate('/faculty/evaluation');
        } catch (err) {
            console.error('Failed to submit bundle', err);
            showSnackbar('Failed to submit bundle. Please try again.', 'error');
        } finally {
            hideLoader();
        }
    };

    const handleFileUploadChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (!file) {
            setFileUploadBase64("");
            return;
        }
        const reader = new FileReader();
        reader.onload = () => {
            const result = reader.result;
            if (typeof result === "string") {
                const base64 = result.includes(",") ? result.split(",")[1] : result;
                setFileUploadBase64(base64);
            } else {
                setFileUploadBase64("");
            }
        };
        reader.readAsDataURL(file);
    };

    // const rows = [
    //     {
    //         id: 1,
    //         bookletId: "#BFWJ38193",
    //         barcode: "/barcodes/bar1.png",
    //         marks: "72/100",
    //         status: "Partially Evaluated",
    //     },
    //     {
    //         id: 2,
    //         bookletId: "#BFWJ38194",
    //         barcode: "/barcodes/bar2.png",
    //         marks: "84/100",
    //         status: "Completed",
    //     },
    //     {
    //         id: 3,
    //         bookletId: "#BFWJ38195",
    //         barcode: "/barcodes/bar3.png",
    //         marks: "--/100",
    //         status: "Pending",
    //     },
    // ];

    const filteredRows = React.useMemo(() => {
        if (!search) return rows;
        const term = search.toLowerCase().trim();
        return rows.filter((row) =>
            [row.bookletId, row.barcode, row.EvaluationStatus]
                .filter(Boolean)
                .some((field: any) => field?.toString().toLowerCase().includes(term))
        );
    }, [rows, search]);

    const statusStyles: Record<string, { background: string; color: string }> = {
        "Completed": { background: "#E6F4EA", color: "#1E7D34" },
        "Pending": { background: "#FFF4E5", color: "#B76E00" },
        "Partially evaluated": { background: "#F3F4F6", color: "#374151" },
    };

    const renderDesktopSkeleton = () => (
        <Box>
            <Header title={state?.data?.title || 'Loading...'} />
            <Box className="mt-4">
                <Paper className='d-flex justify-content-between align-items-start p-3'>
                    <Box>
                        <Skeleton variant="text" width={200} height={28} />
                        <Skeleton variant="text" width={160} height={20} />
                    </Box>
                    <Skeleton variant="rectangular" width={140} height={32} sx={{ borderRadius: 1 }} />
                </Paper>
            </Box>
            <Box className={classes.container} p={4}>
                <Skeleton variant="text" width={180} height={26} />
                <Stack spacing={2} mt={2}>
                    {Array.from({ length: 5 }).map((_, idx) => (
                        <Paper key={idx} sx={{ p: 2 }}>
                            <Skeleton variant="text" width="30%" />
                            <Skeleton variant="text" width="20%" />
                            <Skeleton variant="rectangular" height={36} sx={{ mt: 1, borderRadius: 1 }} />
                        </Paper>
                    ))}
                </Stack>
            </Box>
        </Box>
    );

    const renderMobileSkeleton = () => (
        <Box>
            <Header title={state?.data?.title || 'Loading...'} />
            <Box p={2}>
                <Skeleton variant="text" width={180} height={26} />
                <Stack spacing={2} mt={2}>
                    {Array.from({ length: 4 }).map((_, idx) => (
                        <Paper key={idx} sx={{ p: 2 }}>
                            <Skeleton variant="text" width="70%" />
                            <Skeleton variant="text" width="50%" />
                            <Skeleton variant="rectangular" height={32} sx={{ mt: 1, borderRadius: 1 }} />
                        </Paper>
                    ))}
                </Stack>
            </Box>
        </Box>
    );

    const renderMobileLayout = () => (
        <Box className={classes.mobileWrapper}>
            <Box display="flex" alignItems="center" gap={1}>
                <IconButton size="small" onClick={() => navigate(-1)}>
                    <ArrowBackIosNewIcon fontSize="small" />
                </IconButton>
                <Typography fontWeight={700} color="#171821">{state?.data?.title}</Typography>
            </Box>

            <Box className={classes.mobileSummary}>
                <Typography className={classes.mobileHeading}>
                    {state?.data?.title} - {state?.data?.courseCode}
                </Typography>
                <Typography className={classes.mobileMeta}>{state?.data?.papers} papers | {state?.data?.format}</Typography>
                <Box className={classes.mobileDueChip}>Due date: {dueDateDisplay}</Box>
            </Box>

            <Box className={classes.mobileSection}>
                <Typography className={classes.mobileSectionTitle}>All booklets</Typography>
                <TextField
                    fullWidth
                    placeholder="Search"
                    className={classes.mobileSearchField}
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchIcon />
                            </InputAdornment>
                        ),
                    }}
                />
            </Box>

            {filteredRows.length === 0 ? (
                renderEmptyState("No booklets available for this bundle yet.")
            ) : (
                <Stack spacing={2}>
                    {filteredRows.map((row) => {
                        const statusStyle = statusStyles[row.EvaluationStatus] || statusStyles["Partially evaluated"];
                        const isPending = row.EvaluationStatus === "Pending";
                        const isCompleted = row.EvaluationStatus === "Completed";
                        const totalMarksDisplay = row?.marks || '--/--';
                        const [scored, total] = totalMarksDisplay.split('/') ?? ['--', '--'];
                        return (
                            <Box key={row.id} className={classes.mobileCard}>
                                <Box className={classes.mobileCardHeader}>
                                    <Typography className={classes.mobileBookletId}>#{row.bookletId}</Typography>
                                    <img src={Barcode} alt="barcode" style={{ height: 36 }} />
                                </Box>
                                <Typography className={classes.mobileMarks}>
                                    Total marks: <strong>{scored}</strong>/{total}
                                </Typography>
                                <Box display="flex" alignItems="center" gap={1}>
                                    <Typography className={classes.mobileMarks}>Status:</Typography>
                                    <Box
                                        className={classes.statusChip}
                                        sx={{
                                            backgroundColor: statusStyle.background,
                                            color: statusStyle.color,
                                        }}
                                    >
                                        {row.EvaluationStatus || 'Pending'}
                                    </Box>
                                </Box>
                                <Box sx={{ borderBottom: '1px solid #E5E7EB', mt: 1 }} />
                                <Button
                                    fullWidth
                                    variant="contained"
                                    className={classes.mobileActionBtn}
                                    disabled={isCompleted}
                                    onClick={() => navigate('/faculty/evaluationDetails', {
                                        state: {
                                            data: state,
                                            rowData: row
                                        },
                                    })}
                                    sx={isCompleted ? { backgroundColor: '#ECEFF3', color: '#9DA3AF' } : undefined}
                                >
                                    {isPending ? 'Evaluate' : 'Edit'}
                                </Button>
                            </Box>
                        );
                    })}
                </Stack>
            )}


            <Box className={classes.mobileFooter}>
                <Button
                    fullWidth
                    variant="secondary"
                    onClick={() => setOpen(true)}
                    className={classes.submitButton}
                    disabled={!allCompleted}
                >
                    Submit bundle
                </Button>
            </Box>
        </Box>
    );

    if (loading) {
        return isMobile ? renderMobileSkeleton() : renderDesktopSkeleton();
    }

    return (
        <Box>
            <Header title={state?.data?.title} />
            {isMobile ? (

                <>
                    {renderMobileLayout()}
                    <GlobalModal
                        open={open}
                        title={submitModalTitle}
                        description={submitWarningMessage}
                        cancelText="Go back"
                        confirmText="Submit anyway"
                        onCancel={() => {
                            setOpen(false);
                            resetUploadState();
                        }}
                        onConfirm={handleBundleSubmit}
                        icon={<ErrorOutlineIcon color="error" fontSize="medium" />}
                        children={
                            <TextField
                                key={fileInputKey}
                                fullWidth
                                margin="normal"
                                type="file"
                                label="Upload hallticket"
                                InputLabelProps={{ shrink: true }}
                                inputProps={{ accept: "application/pdf,image/*" }}
                                onChange={handleFileUploadChange}
                                helperText="Upload PDF or image. Sent as base64 with the bundle."
                            />
                        }
                    />
                </>
            ) : (
                <>
                    <Box className="mt-4">
                        <Paper className='d-flex justify-content-between align-items-start'>
                            <Box>
                                <Typography className='fw-bold mb-2'>{state?.data?.title}</Typography>
                                <Typography sx={{ fontSize: '14px' }}>{state?.data?.papers} papers  |  {state?.data?.format}</Typography>
                            </Box>
                            <Typography className={classes.RightChip}>
                                Due date: {dueDateDisplay}
                            </Typography>

                        </Paper>
                    </Box>
                    <Box className={classes.container}>
                        <Box className="d-flex justify-content-between align-items-center p-4" sx={{ borderBottom: '0.5px solid #E6E6E8' }}>
                            <Typography className={classes.header}>All booklets</Typography>
                            <Box className="d-flex gap-3">
                                <TextField
                                    variant="outlined"
                                    placeholder="Search by booklet ID"
                                    value={search}
                                    onChange={(e) => setSearch(e.target.value)}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <SearchIcon />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                                <Button
                                    variant='primary'
                                    onClick={() => navigate("/faculty/markEvaluation", {
                                        state: {
                                            // Pass the complete bundle details so the evaluation page
                                            // can route back with the same context.
                                            data: state?.data,
                                        },
                                    })}
                                >
                                    {hasEvaluationStarted ? "End Evaluation" : "Start Evaluation"}
                                </Button>
                                <Button variant='secondary' disabled={!allCompleted} onClick={() => setOpen(true)}>Submit bundle</Button>
                            </Box>
                        </Box>
                        <Box className="p-4 mt-4">
                            {filteredRows.length > 0 ? (
                                <KenTable columns={columns} rows={filteredRows} showCheckbox={false} />
                            ) : (
                                renderEmptyState("No booklets available for this bundle yet.")
                            )}
                            <GlobalModal
                                open={open}
                                title={submitModalTitle}
                                description={submitWarningMessage}
                                cancelText="Go back"
                                confirmText="Submit anyway"
                                onCancel={() => {
                                    setOpen(false);
                                    resetUploadState();
                                }}
                                onConfirm={handleBundleSubmit}
                                icon={<ErrorOutlineIcon color="error" fontSize="medium" />}
                                children={
                                    <TextField
                                        key={fileInputKey}
                                        fullWidth
                                        margin="normal"
                                        type="file"
                                        label="Upload hallticket"
                                        InputLabelProps={{ shrink: true }}
                                        inputProps={{ accept: "application/pdf,image/*" }}
                                        onChange={handleFileUploadChange}
                                        helperText="Upload PDF or image. Sent as base64 with the bundle."
                                    />
                                }
                            />
                        </Box>
                    </Box>
                </>
            )}
        </Box>
    )
}

export default EvaluatioRequests;
